<template>
  <div class="panel mt-20">
    <router-link
      v-permission="Auth.commodityOrderItemUpdate"
      :to="'/dashboard/shop/orders/editor?customer=' + customerID"
    >
      <el-button type="primary" icon="el-icon-s-order" size="small"
        >新报价</el-button
      >
    </router-link>
    <el-table v-if="!isMobile()" :data="orders" stripe key="orders">
      <el-table-column prop="number" label="单号" width="200">
      </el-table-column>
      <el-table-column
        align="center"
        label="最终客户"
        prop="customer.name"
        min-width="200px"
      >
        <template slot-scope="scope">
          {{ scope.row.customer.name || '无' }}
        </template>
      </el-table-column>
      <el-table-column prop="amount" label="金额(￥)" width="160px">
        <template slot-scope="scope">
          <span>{{ scope.row.total_price.toFixed(2) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态" min-width="200px">
        <template slot-scope="scope">
          <status-tag
            :name="
              CommodityOrderStatusMap[
                scope.row.approve_status == 2 ? 2 : scope.row.status
              ].name
            "
            :type="
              CommodityOrderStatusMap[
                scope.row.approve_status == 2 ? 2 : scope.row.status
              ].type
            "
          >
          </status-tag>
          <span class="text-success" v-if="scope.row.status == 6">{{
            $time(new Date(scope.row.payed_at)).format('YYYY-MM-DD')
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="created_at"
        align="center"
        label="创建日期"
        width="180px"
      >
        <template slot-scope="scope">
          {{ $time(new Date(scope.row.created_at)).format('YYYY-MM-DD HH:mm') }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="220">
        <template slot-scope="scope">
          <router-link
            :to="`/dashboard/shop/application_orders/${scope.row.id}`"
            v-permission="Auth.commodityOrderDetail"
            ><el-button class="ml-10" type="primary" plain size="mini"
              >详情</el-button
            ></router-link
          >
        </template>
      </el-table-column>
    </el-table>
    <ul v-else class="list-style">
      <li v-for="item in orders" :key="item.id">
        <div class="flex-row-between">
          <span>{{ item.number }}</span>
          <span>￥{{ item.total_price.toFixed(2) }}</span>
        </div>
        <div class="font-12 flex-row-between">
          <span>{{ formatTime(item.created_at) }}</span>
          <span>
            <status-tag
              :type="
                CommodityOrderStatusMap[
                  item.approve_status == 2 ? 2 : item.status
                ].type
              "
              :name="
                CommodityOrderStatusMap[
                  item.approve_status == 2 ? 2 : item.status
                ].name
              "
            ></status-tag>
          </span>
        </div>
      </li>
    </ul>
    <div v-if="orders.length == 0 && isMobile()" class="text-info-12">
      暂无报价单。
    </div>
  </div>
</template>

<script>
import {
  CustomerOrderStatusMap,
  CommodityOrderStatusMap,
} from '@/config/global'
import { formatTime, isMobile } from '@/util/index'
import { commodityOrderList } from '@/service/getData'
export default {
  props: {
    customerID: {
      type: Number,
    },
  },
  data() {
    return {
      formatTime,
      isMobile,
      CustomerOrderStatusMap,
      CommodityOrderStatusMap,
      orders: [],
    }
  },
  created() {
    this.requestCustomerOrders()
  },
  methods: {
    async requestCustomerOrders() {
      let res = await commodityOrderList({
        page: 0,
        size: 1000,
        quotation_customer_id: this.customerID,
      })

      if (res.code == 0) {
        this.orders = res.data.list
      }
    },
  },
}
</script>